import React from "react";
import { Button } from "../../../../components/buttons";
import MultipleInputBox from "./multipleInputBox";

export default function WaybillInput(props) {
  return (
    <div className="my-5 py-2 bg-violet-900">
      <div style={{ maxWidth: "1140px" }} className="mx-auto">
        <div
          className="col-md-6 col-sm-8 col-12 p-4 shadow card bg-white mx-auto"
          style={{ borderRadius: 16 }}
        >
          <form>
            <div className="form-row">
              <div className="col-12 mx-auto">
                <div className="d-flex justify-content-between mb-2">
                  <label className="lead lh-150">
                    <strong>Masukkan Nomor Resi (max. 50 resi)</strong>
                  </label>
                  {props.waybillIds.length > 1 || props.waybillIds[0] ? (
                    <Button
                      onClick={() => props.onDeleteRow("all")}
                      className="btn btn-secondary text-xs py-0 px-2 border"
                    >
                      Hapus Semua input
                    </Button>
                  ) : null}
                </div>

                <MultipleInputBox
                  waybillIds={props.waybillIds}
                  onChangeInput={props.onChangeInput}
                  onDeleteRow={props.onDeleteRow}
                  focus={props.focus}
                />

                <Button
                  onClick={() => props.onSubmit()}
                  className="btn btn-primary col-12 mt-4"
                  loading={props.loading}
                >
                  {props.loading ? "Mengambil Resi..." : "Cek Resi"}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
